<template>
  <div class="send-pre-request col-11 col-sm-8 col-md-6 col-lg-4 mx-auto mt-5">
    <p>パスワードの再設定が完了しました。</p>
  </div>
</template>